import PropTypes from "prop-types";
import React from 'react';
import {Link} from "react-router-dom";

const Brand = ({ data }) => {
    return (
        <div className="brand">
            <img src={process.env.PUBLIC_URL + data.image} alt="logo image" />
            {/*<Link to={process.env.PUBLIC_URL + "/"}></Link>*/}
        </div>
    )
}

Brand.propTypes = {
    data: PropTypes.object
}



export default Brand;
